import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-home\">\n<path d=\"M4.4,82.1c-2,1.8-3.4,4.4-3.4,7.4c0,5.3,4.3,9.6,9.6,9.6h19.2v91.2c0,5.3,4.3,9.6,9.6,9.6h31.9c5.3,0,9.6-4.3,9.6-9.6v-38.4\n\th38.4v38.4c0,5.3,4.3,9.6,9.6,9.6h31.9c5.3,0,9.6-4.3,9.6-9.6V99.1h19.2c5.3,0,9.6-4.3,9.6-9.6c0-3-1.5-5.6-3.7-7.4\n\tC162.4,54.4,100,0,100,0S37.6,54.4,4.4,82.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol